<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <h5>Gaze Naturale</h5>
        </div>
        <div class="card-body tab2-card">
          <ngb-tabset class="tab-coupon">
            <ngb-tab title="Contracte furnizare">
              <ng-template ngbTabContent>
                <div class="tab-pane fade active show" id="place" role="tabpanel" aria-labelledby="account-tab">
                  <div class="form-group row">
                    <div class="col-xl-3 col-md-3">
                      <button type="button" class="btn btn-primary" (click)="openSupplierWizard()">
                        Adauga contract/Schimba furnizor
                      </button>
                    </div>
                  </div>
                  <form [formGroup]="contractSupplierForm" class="needs-validation" novalidate>
                    <div class="form-group row">
                      <div class="col-xl-3 col-md-3">
                        <label>CUI / CNP / Numar identificare</label>
                        <input class="form-control" type="text" formControlName="clientCode">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Client</label>
                        <input class="form-control" type="text" formControlName="clientName">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Numar</label>
                        <input class="form-control" type="text" formControlName="contractNumber">
                      </div>
                      <div class="col-xl-1 col-md-1" style="margin-top: auto">
                        <button type="button" class="btn btn-primary" (click)="searchContractSuppliers()">
                          Cauta
                        </button>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-xl-3 col-sm-3 mb-0">
                        <label>CLC</label>
                        <input class="form-control" type="text" formControlName="placeCode">
                      </div>
                      <div class="col-xl-3 col-sm-3 mb-0">
                        <label>Status</label>
                        <input class="form-control" type="text" formControlName="contractStatus">
                      </div>
                    </div>
                  </form>
                  <br>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="contractSupplierSettings" [source]="gasSupplierContracts?.content"
                        (custom)="onCustomActionContractSupplier($event)"></ng2-smart-table>
                    </div>
                  </div>
                  <div>
                    <div *ngIf="gasSupplierContracts?.totalElements">
                      <h4 class="pagination justify-content-center">
                        Total Contracte furnizare: {{gasSupplierContracts?.totalElements}}
                      </h4>
                      <ul class="pagination justify-content-center">
                        <li class="page-item" (click)="previousContractSuppliersPage()">
                          <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                            <span class="sr-only">Previous</span>
                          </a>
                        </li>
                        <li *ngFor="let page of paginationSuppliersContract" [ngClass]="page.className"
                          (click)="changeContractSuppliersPage(page)">
                          <a class="page-link">{{page.pageNumber + 1}}</a>
                        </li>
                        <li class="page-item" (click)="nextContractSuppliersPage()">
                          <a class="page-link" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                            <span class="sr-only">Next</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-tab>
            <ngb-tab>
              <ng-template ngbTabTitle>Contracte retea
                <ng-template ngbTabContent>

                  <form [formGroup]="contractNetworkForm" class="needs-validation" novalidate>
                    <div class="form-group row pb-3">
                      <div class="col-xl-3 col-md-3">
                        <label>CUI OR</label>
                        <input class="form-control" type="text" formControlName="operatorCode">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Denumire OR</label>
                        <input class="form-control" type="text" formControlName="operatorName">
                      </div>
                      <div class="col-xl-3 col-md-3">
                        <label>Numar</label>
                        <input class="form-control" type="text" formControlName="contractNumber">
                      </div>
                      <div class="col-xl-1 col-md-1" style="margin-top: auto">
                        <button type="button" class="btn btn-primary" (click)="searchNetworkContracts()">
                          Cauta
                        </button>
                      </div>
                    </div>
                  </form>

                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="contractNetworkSettings" [source]="gasNetworkContracts?.content"
                        (custom)="onCustomActionContractNetwork($event)">
                      </ng2-smart-table>
                    </div>
                  </div>

                  <div *ngIf="gasNetworkContracts?.totalElements">
                    <h4 class="pagination justify-content-center">
                      Total Contracte retea: {{gasNetworkContracts?.totalElements}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousContractNetworkPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationNetworkContract" [ngClass]="page.className"
                        (click)="changeContractNetworkPage(page)">
                        <a class="page-link">{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextContractNetworkPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>

                </ng-template>
              </ng-template>
            </ngb-tab>
          </ngb-tabset>
        </div>
      </div>
    </div>
  </div>
</div>